import { render, staticRenderFns } from "./ControleNotifications.vue?vue&type=template&id=a3ce86c6&"
import script from "../../../public/js/img/Discoveryjs/Notif/ControleNotification.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/Notif/ControleNotification.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports